import { message } from 'antd';
import { put, select, takeLatest } from 'redux-saga/effects';
import { PhaseEntityType, converToEntityId } from 'data/projects/phase-entity';
import { logger } from 'services';
import { floatUid } from 'utils/uid';
import { addTaskAboveProjectTemplate, addTaskBelowProjectTemplate } from '../../actions';
import { selectTemplateTask } from '../../selectors';
import { createProjectTemplateSubTask, createProjectTemplateTask } from '../../slices';
function* commonGenerator(action, dir) {
    try {
        const { payload: { taskId, payload: newTaskPayload } } = action;
        const task = yield select(selectTemplateTask(taskId));
        const newTask = {
            taskId: floatUid(),
            ...newTaskPayload,
            isNew: true
        };
        if (task.projectPhase) {
            yield put(createProjectTemplateTask({
                task: newTask,
                projectPhaseId: task.projectPhase.projectPhaseId,
                insertAt: {
                    id: converToEntityId(task.taskId, PhaseEntityType.Task),
                    dir
                }
            }));
        } else {
            yield put(createProjectTemplateSubTask({
                task: newTask,
                parentTaskId: task.parentTask.taskId,
                insertAt: {
                    id: task.taskId,
                    dir
                }
            }));
        }
    } catch (error) {
        logger.error('an error while adding a task', {
            error
        });
        message.error('There was an error while adding a task');
    }
}
function* addTaskBelowProjectTemplateSaga(action) {
    yield commonGenerator(action, 1);
}
export function* watchAddTaskBelowProjectTemplateSaga() {
    yield takeLatest(addTaskBelowProjectTemplate.type, addTaskBelowProjectTemplateSaga);
}
function* addTaskAboveProjectTemplateSaga(action) {
    yield commonGenerator(action, 0);
}
export function* watchAddTaskAboveProjectTemplateSaga() {
    yield takeLatest(addTaskAboveProjectTemplate.type, addTaskAboveProjectTemplateSaga);
}
